import {
  ReferenceInstance,
  ReferenceMarket,
  Result,
  ScopedReferenceMarket,
} from '../app/services/api/orderManagementClient';

type ReferenceLookupClient = {
  getAccessibleInstances: () => Promise<Result<ReferenceInstance[]>>;
  getAccessibleMarkets: (instanceId?: string) => Promise<Result<ReferenceMarket[]>>;
};

export const toScopedReferenceMarket = (market: ReferenceMarket): ScopedReferenceMarket => ({
  ...market,
  companyId: market.instanceId,
  customerTypeId: market.id,
});

export const loadAccessibleInstances = async (referenceClient: ReferenceLookupClient): Promise<ReferenceInstance[]> => {
  const response = await referenceClient.getAccessibleInstances();
  return response.success && response.data ? response.data : [];
};

export const loadAccessibleMarkets = async (
  referenceClient: ReferenceLookupClient,
  instanceId?: string,
): Promise<ScopedReferenceMarket[]> => {
  const response = await referenceClient.getAccessibleMarkets(instanceId);
  return response.success && response.data ? response.data.map(toScopedReferenceMarket) : [];
};
